<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">Existing resources</p>
    </header>

    <section class="modal-card-body" >
              <div v-if="noResources">There are no existing resources yet.</div>
        <main class="grid">
          <div v-for="(im,id) in libImages" :key="id">
            <img :src="im.url" @click="selectImage(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">
            <span class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''">{{im.name}}</span>
          </div>
        </main>
     </section>
     <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
         <p><b>Selected image: </b>{{selectedName}}</p>
  </footer>

    <footer class="modal-card-foot">
      <div v-if="!noResources">
      <b-button type="is-info" @click="uploadPicture()">Select</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      </div>
      <div v-else>
<b-button type="is-light" @click="closeModal()">Close</b-button>
      </div>
    </footer>

  </div>
</template>

<script>

export default {
  name: 'PhotoLibrary',
  props: ['isSO', 'propParent'],
  data: () => {
    return {
      libImages: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      noResources: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    if (!this.isSO) {
      var hasItems = false
      if (this.$store.state.menus) {
        for (let men in this.$store.state.menus) {
          var menRef = Object.assign({}, this.$store.getters.getMenu(men))
          if (menRef.items) {
            hasItems = true
            break
          }
        }
      }
      if (this.$store.state.menus === null || hasItems === false) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        for (let menu in this.$store.state.menus) {
          var menuDirsRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + menu)
          } else {
            menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + menu)
          }
          menuDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  var file = new File([blob], fileRef.name, {type: blob.type})
                  // this.globalLogger('size: ', blob.resolution)
                  this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file })
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
    } else {
      var hasItems2 = false
      if (this.$store.state.specialOffers) {
        for (let men in this.$store.state.specialOffers) {
          var menRef2 = Object.assign({}, this.$store.getters.getSpecialOffer(men))
          if (menRef2.items) {
            hasItems2 = true
            break
          }
        }
      }
      if (this.$store.state.specialOffers === null || hasItems2 === false) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        for (let menu in this.$store.state.specialOffers) {
          var soDirsRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            soDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + menu)
          } else {
            soDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + menu)
          }
          soDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  /* var f1 = fileRef.name.split('.')[0]
                  var f2 = fileRef.name.split('.')[1]
                  var file = new File([blob], f1 + '_library.' + f2, {type: blob.type}) */
                  var file = new File([blob], fileRef.name, {type: blob.type})
                  this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file })
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectImage (url, name, file) {
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadPicture () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/items/PhotoLibrary.vue